// Interfaces
import { IUserAccess } from 'interfaces/back-office/user-access'

export const ACCESS_FEATURE_NAME = {
  WEBPAGE: 'WEBPAGE',
  PERSONAL_DATA: 'PERSONAL_DATA',
  LIST_OF_ASSESSMENT: 'LIST_OF_ASSESSMENT',
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  CONTENT_MANAGEMENT: 'CONTENT_MANAGEMENT',
  QA: 'QA',
  USER_ACCESS: 'USER_ACCESS',
  MASTER_DATA: 'MASTER_DATA',
}

export const ACCESS_WEBPAGE: IUserAccess[] = [
  { code: 111, name: 'Home', module: 'WEBPAGE' },
  { code: 112, name: 'About Us', module: 'WEBPAGE' },
  { code: 113, name: 'Sertifikasi', module: 'WEBPAGE' },
  { code: 114, name: 'Asesor', module: 'WEBPAGE' },
  { code: 115, name: 'TUK', module: 'WEBPAGE' },
  { code: 116, name: 'Galeri', module: 'WEBPAGE' },
  { code: 117, name: 'Kontak Kami', module: 'WEBPAGE' },
]

export const ACCESS_BACK_OFFICE_PERSONAL_DATA: IUserAccess[] = [
  { code: 221, name: 'Data Diri Entry', module: 'BACK_OFFICE_PERSONAL_DATA' },
  { code: 222, name: 'Profile / Data Diri', module: 'BACK_OFFICE_PERSONAL_DATA' },
  { code: 223, name: 'Data Perusahaan', module: 'BACK_OFFICE_PERSONAL_DATA'},
  { code: 224, name: 'Kumpulan Dokumen Saya', module: 'BACK_OFFICE_PERSONAL_DATA' },
  { code: 225, name: 'Additional Question', module: 'BACK_OFFICE_PERSONAL_DATA' },
]

export const ACCESS_BACK_OFFICE_LIST_OF_ASSESSMENT: IUserAccess[] = [
  { code: 331, name: 'List of Assessment Entry', module: 'BACK_OFFICE_LIST_OF_ASSESSMENT' },
  { code: 332, name: 'Daftar Asesmen', module: 'BACK_OFFICE_LIST_OF_ASSESSMENT' },
]

export const ACCESS_BACK_OFFICE_USER_MANAGEMENT: IUserAccess[] = [
  { code: 441, name: 'User Manajemen Entry', module: 'BACK_OFFICE_USER_MANAGEMENT' },
  { code: 442, name: 'Menunggu Persetujuan', module: 'BACK_OFFICE_USER_MANAGEMENT' },
  { code: 443, name: 'Disetujui', module: 'BACK_OFFICE_USER_MANAGEMENT' },
  { code: 444, name: 'Ditolak', module: 'BACK_OFFICE_USER_MANAGEMENT' },
]

export const ACCESS_BACK_OFFICE_CONTENT_MANAGEMENT: IUserAccess[] = [
  { code: 551, name: 'Konten Manajemen Entry', module: 'BACK_OFFICE_CONTENT_MANAGEMENT' },
  { code: 552, name: 'Home', module: 'BACK_OFFICE_CONTENT_MANAGEMENT' },
  { code: 553, name: 'Tentang Kami', module: 'BACK_OFFICE_CONTENT_MANAGEMENT' },
  { code: 554, name: 'Sertifikasi', module: 'BACK_OFFICE_CONTENT_MANAGEMENT' },
  { code: 555, name: 'Asesor', module: 'BACK_OFFICE_CONTENT_MANAGEMENT' },
  { code: 556, name: 'TUK', module: 'BACK_OFFICE_CONTENT_MANAGEMENT' },
  { code: 557, name: 'Galeri', module: 'BACK_OFFICE_CONTENT_MANAGEMENT' },
  { code: 558, name: 'Kontak Kami', module: 'BACK_OFFICE_CONTENT_MANAGEMENT' },
]

export const ACCESS_BACK_OFFICE_QA: IUserAccess[] = [
  { code: 881, name: 'QA Entry', module: 'BACK_OFFICE_QA' },
  { code: 882, name: 'QA', module: 'BACK_OFFICE_QA' },
]

export const ACCESS_BACK_OFFICE_MASTER_DATA: IUserAccess[] = [
  { code: 991, name: 'Master Data Entry', module: 'BACK_OFFICE_MASTER_DATA' },
  { code: 992, name: 'Branch', module: 'BACK_OFFICE_MASTER_DATA' },
  { code: 995, name: 'Perusahaan', module: 'BACK_OFFICE_MASTER_DATA' },
  { code: 9911, name: 'Role', module: 'BACK_OFFICE_MASTER_DATA' },
]

export const ACCESS_BACK_OFFICE_USER_ACCESS: IUserAccess[] = [
  { code: 1001, name: 'User Akses Entry', module: 'BACK_OFFICE_USER_ACCESS' },
  { code: 1002, name: 'User Akses', module: 'BACK_OFFICE_USER_ACCESS' },
]

export const ACCESS_ALL: IUserAccess[] = [
  ...ACCESS_BACK_OFFICE_PERSONAL_DATA,
  ...ACCESS_BACK_OFFICE_LIST_OF_ASSESSMENT,
  ...ACCESS_BACK_OFFICE_USER_MANAGEMENT,
  ...ACCESS_BACK_OFFICE_CONTENT_MANAGEMENT,
  ...ACCESS_BACK_OFFICE_QA,
  ...ACCESS_BACK_OFFICE_MASTER_DATA,
  ...ACCESS_BACK_OFFICE_USER_ACCESS,
]

// ACCESS CODE GROUP
export const ACCESS_CODE_WEBPAGE: number[] = ACCESS_WEBPAGE.map(access => access.code)
export const ACCESS_CODE_PERSONAL_DATA: number[] = ACCESS_BACK_OFFICE_PERSONAL_DATA.map(access => access.code)
export const ACCESS_CODE_LIST_OF_ASSESSMENT: number[] = ACCESS_BACK_OFFICE_LIST_OF_ASSESSMENT.map(access => access.code)
export const ACCESS_CODE_USER_MANAGEMENT: number[] = ACCESS_BACK_OFFICE_USER_MANAGEMENT.map(access => access.code)
export const ACCESS_CODE_CONTENT_MANAGEMENT: number[] = ACCESS_BACK_OFFICE_CONTENT_MANAGEMENT.map(access => access.code)
export const ACCESS_CODE_QA: number[] = ACCESS_BACK_OFFICE_QA.map(access => access.code)
export const ACCESS_CODE_USER_ACCESS: number[] = ACCESS_BACK_OFFICE_USER_ACCESS.map(access => access.code)
export const ACCESS_CODE_MASTER_DATA: number[] = ACCESS_BACK_OFFICE_MASTER_DATA.map(access => access.code)
